import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import TravelCreditDetail from './TravelCreditDetail';

const SingleTravelCredit = ({
  travelCreditsData,
  membershipData,
  hasTravelCreditCenturionCardArt,
}) => {
  const { formatMessage } = useIntl();
  const selectedTravelCredit = travelCreditsData[0] || {};

  return (
    <div>
      <h3 className="heading-1 margin-b hidden-sm-down">
        {formatMessage({ id: 'travelCreditTab.heading' })}
      </h3>
      <TravelCreditDetail
        membershipData={membershipData}
        selectedTravelCredit={selectedTravelCredit}
        hasTravelCreditCenturionCardArt={hasTravelCreditCenturionCardArt}
      />
    </div>
  );
};

SingleTravelCredit.propTypes = {
  travelCreditsData: PropTypes.arrayOf({}),
  membershipData: PropTypes.shape({
    travelCredits: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  hasTravelCreditCenturionCardArt: PropTypes.bool.isRequired,
};

export default SingleTravelCredit;
